import { render, staticRenderFns } from "./OrdersMapsFilters.vue?vue&type=template&id=2f4ebe72"
import script from "./OrdersMapsFilters.vue?vue&type=script&lang=js"
export * from "./OrdersMapsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports